//======================================================================================================
//
// This store will hold information on importing
//
//======================================================================================================

import { defineStore } from "pinia";
import { ImportType } from "@/types/import";

export const useImportStore = defineStore("importStore", {
	state: () =>
		({
			isOpen: false,
			activeImport: {
				type: "drillhole"
			},
			finalizingUploads: {},
			isBlastDogDatasetInProgress: false
		}) as ImportType,
	actions: {
		close() {
			this.isOpen = false;
		},
		open(payload: {
			type: string;
			group?: string;
			folderPath?: string;
			subFolderOptions: string[];
			isBlastDogDatasetInProgress?: boolean;
		}) {
			this.activeImport.type = payload.type;
			if (payload.group != "" && payload.group != null)
				this.activeImport.group = payload.group;
			if (payload.folderPath != null) this.activeImport.folderPath = payload.folderPath;
			if (payload.subFolderOptions != null)
				this.activeImport.subFolderOptions = payload.subFolderOptions;

			this.isBlastDogDatasetInProgress = payload.isBlastDogDatasetInProgress;
			this.isOpen = true;
		},
		setIsBlastDogDatasetInProgress(isInProgress: boolean) {
			this.isBlastDogDatasetInProgress = isInProgress;
		}
	}
});
